var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "generate-token-page" } },
    [
      _c("page-heading", {
        attrs: {
          "page-title": "Token Generation",
          links: [
            { target: "#help-modal", text: "Help" },
            { target: "/", text: "Login" }
          ]
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container", attrs: { id: "content" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "page-alert",
                { class: { invisible: _vm.isBridgeConnected } },
                [
                  _c("div", { attrs: { slot: "message" }, slot: "message" }, [
                    _vm._v("Error connecting to the Real-time Interface")
                  ])
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "div",
              {
                staticClass: "col-8 mr-auto ml-auto form-group",
                attrs: { id: "token-info-input" }
              },
              [
                _c(
                  "form",
                  {
                    staticClass: "form-group",
                    attrs: {
                      id: "generate-token-form",
                      novalidate: "",
                      autocomplete: "off"
                    },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.generateToken()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-group row",
                        attrs: { id: "user-id" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-2 col-form-label",
                            attrs: { for: "user-id-input" }
                          },
                          [_vm._v("User ID")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.userId.value,
                                expression: "userId.value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "user-id-input",
                              placeholder: "User ID",
                              required: ""
                            },
                            domProps: { value: _vm.userId.value },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.userId,
                                  "value",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v("Enter a user ID")
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group row",
                        attrs: { id: "telescope" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-2 col-form-label",
                            attrs: { for: "telescope-input" }
                          },
                          [_vm._v("Telescope")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.telescope.value,
                                  expression: "telescope.value"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { id: "telescope-input", required: "" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.telescope,
                                    "value",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("Select a telescope...")
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.availableTelescopes, function(
                                telescope
                              ) {
                                return _c(
                                  "option",
                                  { domProps: { value: telescope } },
                                  [_vm._v(_vm._s(telescope.name))]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v("Select a telescope")
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group row",
                        attrs: { id: "date-range" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-2 col-form-label",
                            attrs: { for: "date-range-input" }
                          },
                          [_vm._v("Date")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.dateRange.value,
                                expression: "dateRange.value"
                              }
                            ],
                            staticClass: "form-control flatpickr-readonly",
                            attrs: {
                              id: "date-range-input",
                              placeholder: "Select a date...",
                              required: ""
                            },
                            domProps: { value: _vm.dateRange.value },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.dateRange,
                                  "value",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v("Select a date")
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group row",
                        attrs: { id: "start-time" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-2 col-form-label",
                            attrs: { for: "start-time-input" }
                          },
                          [_vm._v("Time")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.startTime.value,
                                  expression: "startTime.value"
                                }
                              ],
                              staticClass: "form-control flatpickr-readonly",
                              attrs: {
                                id: "start-time-input",
                                placeholder: "Select a start time...",
                                required: ""
                              },
                              domProps: { value: _vm.startTime.value },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.startTime,
                                    "value",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "input-group-addon" }, [
                              _vm._v("UTC")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v("Select a start time")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.endTime.value,
                                  expression: "endTime.value"
                                }
                              ],
                              staticClass: "form-control flatpickr-readonly",
                              attrs: {
                                id: "end-timestamp-input",
                                placeholder: "Select an end time...",
                                required: ""
                              },
                              domProps: { value: _vm.endTime.value },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.endTime,
                                    "value",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "input-group-addon" }, [
                              _vm._v("UTC")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v("Select an end time")
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group row",
                        attrs: { id: "password" }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "col-2 col-form-label",
                            attrs: { for: "password-input" }
                          },
                          [_vm._v("Password")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.password.value,
                                expression: "password.value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "password-input",
                              type: "password",
                              placeholder: "Password",
                              required: ""
                            },
                            domProps: { value: _vm.password.value },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.password,
                                  "value",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(_vm._s(_vm.password.feedback))
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group row",
                        attrs: { id: "generated-token" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.token.value,
                              expression: "token.value"
                            }
                          ],
                          staticClass: "form-control col",
                          attrs: {
                            type: "text",
                            id: "token-string",
                            placeholder: "Generated token",
                            readonly: ""
                          },
                          domProps: { value: _vm.token.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.token, "value", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(_vm._s(_vm.token.feedback))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "input-group-btn" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: {
                                id: "copy-token",
                                type: "button",
                                "data-clipboard-target": "#token-string",
                                "data-toggle": "popover",
                                disabled: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.copiedPopover()
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../img/ic_content_copy_black_24px.svg"),
                                  alt: "Copy to clipboard"
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row pb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col",
                          staticStyle: {
                            color: "#dc3545",
                            "font-size": ".875rem"
                          }
                        },
                        [_vm._v(_vm._s(_vm.token.feedback))]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "row pb-5",
                        attrs: { id: "generate-button" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col d-flex justify-content-center" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "submit",
                                  disabled: !_vm.isBridgeConnected
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Generate\n              "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("help-modal", [
              _c("div", { attrs: { slot: "help-text" }, slot: "help-text" }, [
                _c("p", [
                  _vm._v(
                    "\n            Allows an authorized user or application to generate login tokens for the Real-time Interface (RTI). All\n            of the fields on this page must be supplied. The generated token will be valid to login to the RTI\n            during the session as well as 5 minutes before the session start and 15 minutes after the session end.\n            Please copy this token and store it for later use with the RTI.\n          "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            The password is provided by the Observing Manager and is not part of any wider LCO user management.\n          "
                  )
                ])
              ])
            ])
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }